var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionEnum, INITIAL_STATE } from './store';
export default function reducer(state, action) {
    var _a;
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case ActionEnum.SET_VISIBILITY: {
            return __assign(__assign({}, state), { visibleFieldList: action.fieldNameList });
        }
        case ActionEnum.RESET_FIELD: {
            return __assign(__assign({}, state), { resetFields: __assign(__assign({}, state.resetFields), (_a = {}, _a[action.fieldName] = !state.resetFields[action.fieldName], _a)) });
        }
        case ActionEnum.SET_FIELD_OPTIONS: {
            return __assign(__assign({}, state), { fieldsOptions: action.optionsList });
        }
        case ActionEnum.SET_VALUE: {
            return __assign(__assign({}, state), { values: __assign(__assign({}, state.values), action.value) });
        }
        case ActionEnum.SET_VALUES: {
            return __assign(__assign({}, state), { values: action.values });
        }
        case ActionEnum.SET_CONSTRAINTS: {
            return __assign(__assign({}, state), { constraints: action.constraints });
        }
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map